import { boardPublicPath } from "@/config/browserBoard";

type OpenWindow = (
  url: string,
  target: string,
  features: string,
) => Window | null;

/** ブロックされた別ウィンドウの代わりに現在のタブを遷移させる関数。 */
type Navigate = (url: string) => void;

// standalone=1 でヘッダー・サイドメニュー無しのジュークボックス単独表示にする
// (__root.tsx のレイアウト分岐が参照するマーカー)。
const JUKEBOX_PATH = "/jukebox?standalone=1";
const JUKEBOX_WINDOW_TARGET = "_blank";
// width/height を指定し、旧版同様に独立したウィンドウとして開かせる
// (寸法を指定しない window.open はブラウザによって新規タブとして開かれ、
// 別ウィンドウ化にならない)。
// noopener/noreferrer は指定しない: noopener を含めると window.open が
// 成功時にも null を返す仕様のため、ポップアップブロック検知(null判定)と
// 両立せず、成功時までフォールバック遷移が発火して二重表示になる。
// 開き先は同一オリジンの自ページなので、opener の切断は取得後の代入で行う。
const JUKEBOX_WINDOW_FEATURES =
  "width=440,height=760,menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes";

const defaultNavigate: Navigate = (url: string): void => {
  window.location.assign(url);
};

/**
 * ジュークボックスを別ウィンドウで開く。ポップアップブロッカー等で
 * window.open がブロックされ null が返った場合(残余リスク)は、
 * 別ウィンドウを諦めて現在のタブでジュークボックスへ遷移する
 * フォールバックを行う。
 */
export function openJukeboxWindow(
  openWindow: OpenWindow,
  navigate: Navigate = defaultNavigate,
): Window | null {
  const jukeboxUrl = boardPublicPath(JUKEBOX_PATH);
  const win = openWindow(
    jukeboxUrl,
    JUKEBOX_WINDOW_TARGET,
    JUKEBOX_WINDOW_FEATURES,
  );
  if (win === null) {
    navigate(jukeboxUrl);
    return null;
  }
  // noopener 相当の逆タブナビング対策(同一オリジンのため代入可能)
  win.opener = null;
  return win;
}
